<div #ribbonBanner class="poker-ribbon" *ngIf="isEnabled" [attr.data-id]="item.name">
    <div class="clearfix text-right">
        <span style="position: relative; z-index: 1" class="ui-icon theme-close-i" (click)="closeRibbon()"></span>
    </div>
    <ng-container *ngFor="let child of item.items">
        <!-- <ng-container *vnPageMatrix="child"></ng-container> -->
        <vn-page-matrix [content]="child"></vn-page-matrix>
    </ng-container>
</div>
